import { clockedInTempStaff, clockOutableStaff } from '../../Game/GamePlayerInfo';

function doIhaveFate(gamePlayerController, aiPackage) {
    const currentFate = gamePlayerController.gamePlayerData.current_fate;
    const result = currentFate > 0;
    const question = 'What about Fate?';
    let reason = 'There is no Fate but what we make';
    if (result) {
        reason = `I have Fate (${currentFate}), Now I must Act.`;
        aiPackage.complete = false;
        aiPackage.addToMessage('Fate is against us');
    } else {
        aiPackage.addToMessage('There is no Fate but what we make');
        aiPackage.complete = true;
    }
    aiPackage.addProvenance(question, result, reason);
    return result;
}


function shouldIAntiJuice(gamePlayerController, aiPackage) {
    // attack or build matters....
    // I want 2, 3, 4, 5, 6, 7, 8;
    let available = clockOutableStaff(gamePlayerController.gamePlayerData);
    let result = available.length > 0;
    let question = 'Do I have available staff for Clock-Out?';
    let reason = 'There are none available.';
    if (result) {
        reason = `There are ${available.length} available.`;
    }
    aiPackage.addProvenance(question, result, reason);
    if (!result) {
        return false;
    }

    let want = 2;
    const current = clockedInTempStaff(gamePlayerController.gamePlayerData).length;
    result = current > want;
    question = 'Clock-Out Available Staff to Anti-Juice?';
    reason = `I want ${want} and I have ${current}.`;
    aiPackage.addProvenance(question, result, reason);
    return result;
}


function setJuice(gamePlayerController, aiPackage) {
    let clockedOutStaff = [];
    const staffMember = clockOutableStaff(gamePlayerController.gamePlayerData).pop();
    clockedOutStaff.push(staffMember);
    aiPackage.clockedOutStaff = clockedOutStaff;
    aiPackage.addToMessage(`Clock Out Staff #${staffMember}`);
}


export default function artificialAntiJuice(gamePlayerController, aiPackage) {

    doIhaveFate(gamePlayerController, aiPackage);

    if (!aiPackage.complete && shouldIAntiJuice(gamePlayerController, aiPackage)) {
        setJuice(gamePlayerController, aiPackage);
    } else {
        aiPackage.addToMessage('We can not resist');
    }

    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickAntiJuice(aiPackage.clockedOutStaff);
    }

    aiPackage.success = true;
    return aiPackage;
}
